import { Component, effect, input, output, signal } from '@angular/core';
import { TestCase } from '@shared/models/test-case';
@Component({
  selector: 'app-test-case-item',
  templateUrl: './test-case-item.html',
})
export class TestCaseItem {
  data = input<TestCase>();
  dataChanged = output<Partial<TestCase>>();
  deleteButtonClicked = output();
  index = input<number>();
  disabled = input<boolean>(false);
  inputValue = signal('');
  expectedOutput = signal('');
  timeLimit = signal<number | null>(null);
  memoryLimit = signal<number | null>(null);
  isExpanded = signal(false);
  isVisible = signal<boolean>(true);

  constructor() {
    effect(() => {
      const d = this.data;
      if (d) {
        this.inputValue.set(d()!.input);
        this.expectedOutput.set(d()!.expectedOutput);
        this.timeLimit.set(d()!.timeLimit);
        this.memoryLimit.set(d()!.memoryLimit);
        this.isExpanded.set(d()!.isExpanded ?? false);
        this.isVisible.set(d()!.isVisible ?? true);
      }
    });
  }
  toggleExpand() {
    this.isExpanded.set(!this.isExpanded());
    this.emitDataChanged();
  }

  onInputChanged(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.inputValue.set(val);
    this.emitDataChanged();
  }

  onVisibleChanged(event: Event) {
    const isChecked = (event.target as HTMLInputElement)?.checked ?? false;
    this.isVisible.set(isChecked);
    this.emitDataChanged(); // Notify parent about the change
  }

  onExpectedOutputChanged(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.expectedOutput.set(val);
    this.emitDataChanged();
  }

  emitDataChanged() {
    this.dataChanged.emit({
      input: this.inputValue(),
      expectedOutput: this.expectedOutput(),
      timeLimit: this.timeLimit(),
      memoryLimit: this.memoryLimit(),
      isExpanded: this.isExpanded(),
      isVisible: this.isVisible(),
    });
  }
  onTimeLimitChanged(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const num = value.trim() === '' ? null : Number(value);
    this.timeLimit.set(isNaN(num!) ? null : num);
    this.emitDataChanged();
  }
  onMemoryLimitChanged(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    const num = value.trim() === '' ? null : Number(value);
    this.memoryLimit.set(isNaN(num!) ? null : num);
    this.emitDataChanged();
  }
}
